import { jsx as _jsx } from "react/jsx-runtime";
import { DragDropProvider } from '@dnd-kit/react';
export const DndProvider = ({ sensors, modifiers, onDragStart, onDragEnd, children }) => (_jsx(DragDropProvider, { sensors: sensors, modifiers: modifiers, onDragStart: onDragStart, onDragEnd: onDragEnd, children: children }));
